// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"system-unlocked"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M16 16.5H23V21H16V16.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 9V3H2V17H12M4 21H12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17.2515 16.5V14.75C17.2515 13.5074 18.2588 12.5 19.5015 12.5C20.1203 12.5 20.6808 12.7498 21.0875 13.1541M16 16.5H23V21H16V16.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SystemUnlockedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-unlocked',
    ref,
    icon: element,
  },
));

SystemUnlockedIcon.displayName = 'SystemUnlockedIcon';

export default SystemUnlockedIcon;
